









































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { DxDataGrid, DxColumn, DxPaging, DxPager, DxFilterRow, DxFilterPanel, DxButton, DxSearchPanel } from "devextreme-vue/data-grid";
import { DxGridColumnConfig } from '@/services/$gridColumnsProvider';

@Component({
  components: {
    DxDataGrid,
    DxPaging,
    DxColumn,
    DxPager,
    DxFilterRow,
    DxFilterPanel,
    DxButton,
    DxSearchPanel
  }
})
export default class DataGrid extends Vue {
  @Prop({
    required: true
  })
  public entity!: string;

  @Prop({
    required: false
  })
  public filters!: any;

  @Prop() public showEditButton!: boolean;

  public get renderActionColumn(): boolean {
    return this.showEditButton === true;
  }

  public get columns(): DxGridColumnConfig[] {
    return Vue.$gridColumnsProvider[this.entity];
  }

  public get actionButtons() {
    return [
      {
        hint: 'Modifica',
        icon: 'edit',
        visible: this.showEditButton,
        onClick: this.onEditButtonClick
      }
    ]
  }

  public dataSource: any[] = [];

  constructor() {
    super();
  }

  async mounted() {
    this.fetchData();
  }

  public async fetchData(): Promise<void> {
    const dataGridItems = await Vue.$svc.entityList<any>(this.entity, this.filters);
    this.dataSource = dataGridItems;
  }

  public onRowDoubleClick($event: any) {
      console.info('-> $event was', $event);
      this.rowDoubleClick($event.data);
  }

  /**
   * Invocato dalla datagrid quando viene cliccato il pulsante modifica (se mostrato).
   */
  public onEditButtonClick($event: any) {
    this.onEditButtonClicked($event.row.data);
  }

  public onSelectionChanged($event: any) {
    const selectedRowsData = $event.selectedRowsData;
    const selectedRecord = selectedRowsData[0];
    this.onItemSelected(selectedRecord);
  }

  @Emit('onEditButtonClicked')
  public onEditButtonClicked($event: any) {
    // console.info('-> edit button clicked');
  }

  @Emit('onItemSelected')
  public onItemSelected($event: any) {
    // console.info('-> item selected');
  }

  @Emit('rowDoubleClick')
  public rowDoubleClick($event: any) {
    console.info('should emit data...');
  }
}
